<template>
  <ContentLoader viewBox="0 0 375 650" v-if="show">
    <!-- video -->
    <rect x="0" y="0" rx="0" ry="0" width="375" height="212" />

    <!-- userinfo -->
    <rect x="10" y="218" rx="2" ry="2" width="355" height="15" />
    <circle cx="30" cy="268" r="20" />
    <rect x="69" y="249" rx="2" ry="2" width="140" height="15" />
    <rect x="69" y="273" rx="2" ry="2" width="275" height="15" />
    <rect x="0" y="300" rx="2" ry="2" width="375" height="5" />

    <!-- tab -->
    <rect x="10" y="320" rx="0" ry="0" width="80" height="35" />
    <rect x="100" y="320" rx="0" ry="0" width="80" height="35" />
    <rect x="190" y="320" rx="0" ry="0" width="80" height="35" />
    <rect x="280" y="320" rx="0" ry="0" width="80" height="35" />

    <!-- tab content -->
    <rect x="10" y="370" rx="0" ry="0" width="350" height="40" />
    <rect x="10" y="420" rx="0" ry="0" width="350" height="40" />
    <rect x="10" y="470" rx="0" ry="0" width="350" height="40" />
    <rect x="10" y="520" rx="0" ry="0" width="350" height="40" />
    <rect x="10" y="570" rx="0" ry="0" width="350" height="40" />
  </ContentLoader>
</template>

<script>
import { defineComponent } from "vue";
import { ContentLoader } from "vue-content-loader";

export default defineComponent({
  name: "PlaySkeleton",
  components: { ContentLoader },
  props: { show: Boolean },
  emits: {},
  setup() {
    return {};
  },
});
</script>
